import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import MasterLayout from "./components/MasterLayout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Customers from "./pages/Customers";
import CustomerDetail from "./pages/CustomerDetail";
import Storages from "./pages/Storages";
import StorageDetail from "./pages/StorageDetail";
import History from "./pages/History";
import Reminders from "./pages/Reminders";
import Payments from "./pages/Payments";
import SalesStock from "./pages/SalesStock";
import Staff from "./pages/Staff";
import Reports from "./pages/Reports";
import Subscription from "./pages/Subscription";
import Settings from "./pages/Settings";
import PayTRMock from "./pages/PayTRMock";
import MasterDashboard from "./pages/master/MasterDashboard";
import MasterTenants from "./pages/master/MasterTenants";
import MasterPlans from "./pages/master/MasterPlans";
import MasterPaymentSettings from "./pages/master/MasterPaymentSettings";
import MasterSubscriptions from "./pages/master/MasterSubscriptions";
import MasterEmailSettings from "./pages/master/MasterEmailSettings";
import MasterHelpVideos from "./pages/master/MasterHelpVideos";
import MasterProfile from "./pages/master/MasterProfile";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/sifre-unuttum" element={<ForgotPassword />} />
          <Route path="/sifre-sifirla" element={<ResetPassword />} />

          {/* Master routes */}
          <Route
            path="/master"
            element={
              <ProtectedRoute requireRole="master">
                <MasterLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<MasterDashboard />} />
            <Route path="isletmeler" element={<MasterTenants />} />
            <Route path="paketler" element={<MasterPlans />} />
            <Route path="abonelikler" element={<MasterSubscriptions />} />
            <Route path="odeme-ayarlari" element={<MasterPaymentSettings />} />
            <Route path="eposta-ayarlari" element={<MasterEmailSettings />} />
            <Route path="yardim-videolari" element={<MasterHelpVideos />} />
            <Route path="profil" element={<MasterProfile />} />
          </Route>

          {/* Tenant routes */}
          <Route
            element={
              <ProtectedRoute requireRole="tenant">
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/musteriler" element={<Customers />} />
            <Route path="/musteriler/:id" element={<CustomerDetail />} />
            <Route path="/emanetler" element={<Storages />} />
            <Route path="/emanetler/:id" element={<StorageDetail />} />
            <Route path="/hatirlatmalar" element={<Reminders />} />
            {/* Satış/Stok — pakette pasifse panoya yönlendirilir (şartname #10) */}
            <Route
              path="/satis-stok"
              element={
                <ProtectedRoute requireModule="sales_stock">
                  <SalesStock />
                </ProtectedRoute>
              }
            />
            <Route path="/odemeler" element={<Payments />} />
            <Route path="/gecmis" element={<History />} />
            <Route path="/raporlar" element={<Reports />} />
            <Route path="/abonelik" element={<Subscription />} />
            <Route path="/odeme/paytr-mock" element={<PayTRMock />} />
            <Route
              path="/personel"
              element={
                <ProtectedRoute requireRole="owner">
                  <Staff />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ayarlar"
              element={
                <ProtectedRoute requireRole="owner">
                  <Settings />
                </ProtectedRoute>
              }
            />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
